import {LogoAnimation} from "components";
import GeoBlockGate from "components/GeoBlockGate";
import PrivateRoute from "components/PrivateRoute";
import TokenRefreshCheck from "components/TokenRefreshCheck";
import {useFaviconHook, usePageTrackingHook, useTabIsActiveHook, useVersionChangeHook} from "hooks";
import {Layout} from "mapx-components/Layout";
import React, {Suspense, useMemo} from "react";
import {useSelector} from "react-redux";
import {Redirect, Route, Switch} from "react-router-dom";
import {userLicenseTypeNameSelector, userSelector} from "store/user/userSelectors";
import {AppRoute} from "types";
import routes from "./routes";

const getRoutes = (links: Array<AppRoute>, isAuthenticated: boolean) => {
	return links.map((route, i) => {
		const {component: Component, ...rest} = route;

		if (route.private) {
			return <PrivateRoute key={i} {...route} isAuthenticated={isAuthenticated} />;
		}

		return <Route key={i} {...rest} render={(props) => <Component {...props} />} />;
	});
};

const AppContainer: React.FC = () => {
	const user = useSelector(userSelector);
	const userLicenseTypeName = useSelector(userLicenseTypeNameSelector);

	const isAuthenticated = !!user?.email;

	useVersionChangeHook();
	usePageTrackingHook();

	const {tabIsActive} = useTabIsActiveHook();
	useFaviconHook(tabIsActive);

	const shouldDisplayOnBoarding =
		userLicenseTypeName === "Starter" || userLicenseTypeName === "Plus";

	const filteredRoutes = useMemo(
		() => routes(shouldDisplayOnBoarding),
		[shouldDisplayOnBoarding],
	);

	return (
		<GeoBlockGate>
			<Layout>
				<Suspense
					fallback={
						<div
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								height: "100vh",
							}}
						>
							<LogoAnimation />
						</div>
					}
				>
					<TokenRefreshCheck />
					<Switch>
						<Redirect from="/projects/:id" to="/project/:id" />{" "}
						{getRoutes(filteredRoutes, isAuthenticated)}{" "}
					</Switch>
				</Suspense>
			</Layout>
		</GeoBlockGate>
	);
};

export default AppContainer;
